import {createPortal} from 'react-dom';

import {FCWithChildren} from 'app/interface';

const GEM_CONTENT_READY_ATTR = 'data-content-ready';

export const ComponentPortal: FCWithChildren<ComponentPortalProps> = ({children, element, removeContent}) => {
    if (removeContent && !element.hasAttribute(GEM_CONTENT_READY_ATTR)) {
        if (element.innerHTML.includes('<gem-')) {
            console.error('Web Component inside portal target!', element);
        }

        element.innerHTML = '';
        element.setAttribute(GEM_CONTENT_READY_ATTR, '');
    }

    return createPortal(children, element);
};

type ComponentPortalProps = {
    element: HTMLElement;
    removeContent: boolean;
};
